
import { Union } from "../fable_modules/fable-library-js.5.0.0-alpha.22/Types.js";
import { union_type, list_type, string_type } from "../fable_modules/fable-library-js.5.0.0-alpha.22/Reflection.js";
import { int32ToString } from "../fable_modules/fable-library-js.5.0.0-alpha.22/Util.js";
import { Decimal_Format_32C73145 } from "./Basics.jsx";

export class Ausdruck extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Empty", "Text", "Number", "Bruch", "Editor", "InvalidEditor", "IstGleich", "IstGleichMitFaktor", "Einheit", "Ausdrücke"];
    }
}

export function Ausdruck_$reflection() {
    return union_type("MatheApp.Domain.Ausdruck", [], Ausdruck, () => [[], [["Item", string_type]], [["Item", string_type]], [["Item1", Ausdruck_$reflection()], ["Item2", Ausdruck_$reflection()]], [["Item", Ausdruck_$reflection()]], [["Item", Ausdruck_$reflection()]], [["Item1", Ausdruck_$reflection()], ["Item2", Ausdruck_$reflection()]], [["Item1", Ausdruck_$reflection()], ["Item2", Ausdruck_$reflection()], ["Item3", Ausdruck_$reflection()]], [["Item1", Ausdruck_$reflection()], ["Item2", string_type]], [["Item", list_type(Ausdruck_$reflection())]]]);
}

export function AusdruckModule_ofInt(value) {
    return new Ausdruck(2, [int32ToString(value)]);
}

export function AusdruckModule_ofDecimal(value) {
    return new Ausdruck(2, [Decimal_Format_32C73145(value)]);
}

export function AusdruckModule_ofString(value) {
    return new Ausdruck(1, [value]);
}

export function AusdruckModule_get(value) {
    return value.Ausdruck;
}

export function Ausdruck_op_Implicit_Z6CF8F56C(value) {
    return AusdruckModule_get(value);
}

export function Ausdruck_op_Implicit_Z721C83C5(value) {
    return AusdruckModule_ofString(value);
}

export function Ausdruck_op_Implicit_32C73145(value) {
    return AusdruckModule_ofDecimal(value);
}

export function Ausdruck_op_Implicit_Z524259A4(value) {
    return AusdruckModule_ofInt(value);
}

